import flat from 'array.prototype.flat';
import flatMap from 'array.prototype.flatmap';

Array.prototype.flat = flat.getPolyfill(); //function () { return flat(arguments) };
Array.prototype.flatMap = flatMap.getPolyfill(); // function () { return flatMap(arguments) };
